import { useTranslation } from 'react-i18next';

const usePreviewButton = (GTMEvent: (buttonText: string) => void, watchPreview: VoidFunction) => {
	const { t } = useTranslation();

	const buttonText = t('button_preview');

	const handleClick = () => {
		watchPreview();
		GTMEvent && GTMEvent(buttonText);
	};

	return {
		handleClick,
		buttonText
	};
};

export default usePreviewButton;
